<template>
  <div id="js-pagetop" class="l-pagetop">
    <a href="#pagetop" class="l-pagetop__link" />
  </div>
</template>

<script>
export default {
  name: 'Pagetop',
  mounted() {
    this.fixPosition();

    window.addEventListener('scroll', () => {
      this.fixPosition();
    });
  },
  methods: {
    fixPosition() {
      document.getElementById(
        'js-pagetop',
      ).style.left = `-${window.pageXOffset}px`;
    },
  },
};
</script>

<style lang="scss">
@import '../scss/breakpoint';
@import '../scss/function';

.l-pagetop {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 30px;
  pointer-events: none;
  @include desktop {
    min-width: 1080px;
  }
  .l-pagetop__link {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 30px;
    background: $color_lightgray;
    border-radius: 9px 0 0 0;
    pointer-events: auto;
    @include desktop {
      transition: background-color 0.5s cubic-bezier(0.5, 1, 0.89, 1);
      &:hover {
        background: #e0f4f0;
      }
    }
    &::before {
      display: block;
      content: '';
      border-top: 2px solid $color_primary;
      border-left: 2px solid $color_primary;
      width: 13px;
      height: 13px;
      transform: translateY(3px) rotateZ(45deg);
    }
  }
}
</style>
